import Detail from "./Detail.page";

export default Detail;
